import { SVGProps } from 'react'

import styles from './MenuItem.module.scss'

interface SideMenuItemProps {
  active: boolean
  icon: React.FC<SVGProps<SVGSVGElement>>
  title: string
}

const SideMenuItem = ({ active, icon: Icon, title }: SideMenuItemProps) => (
  <div className={styles.menuItem} {...(active ? { active: '' } : {})}>
    <Icon />
    {title}
  </div>
)

export default SideMenuItem
